import React from 'react';
import cn from 'classnames';

import {ITariff} from 'entities/tariff';

import {TARIFF_FEATURES} from './tariffFeatureList';

import styles from './TariffFeatures.module.scss';

interface ITariffFeaturesProps {
    item: ITariff,
}

const TariffFeatures: React.FC<ITariffFeaturesProps> = ({item}) => (
    <div className={styles.features}>
        {
            TARIFF_FEATURES.map(({key, label, title}) =>
                <span
                    key={key}
                    title={title}
                    className={cn(styles.feature, item[key] ? styles.featureOn : styles.featureOff)}
                >
                    {label}
                </span>,
            )
        }
    </div>
);

export default React.memo(TariffFeatures);
